import { useContext } from 'react';

import { useQuery as useQueryOriginal } from '@tanstack/react-query';
import capitalize from 'lodash/capitalize';

import { useDebug } from 'components/Debug';

import MessageContext from './MessageContext';

export const useQuery = (queryKey: any, queryFn: any, options: any = {}) => {
  const { showErrorMessage } = useContext(MessageContext);
  const { onSuccess, initialData, onError } = options;
  const { empty, skeleton, error, fetching } = useDebug();

  const queryResult = useQueryOriginal(queryKey, queryFn, {
    onSuccess: (data: any, ...other: any) => {
      return onSuccess && onSuccess(data, ...other);
    },
    onError: onError
      ? onError
      : (e: any) => {
          const queryPreview = queryKey
            .filter((el: any) => typeof el === 'string')
            .map(capitalize)
            .join('->');
          showErrorMessage(`${queryPreview} ${e.message}`);
        },
    initialData,
  });

  if (skeleton) {
    return { ...queryResult, isLoading: true, isSuccess: false };
  }

  if (fetching) {
    return { ...queryResult, isFetching: true, isRefetching: true };
  }

  if (empty) {
    return { ...queryResult, data: null };
  }

  if (error) {
    return { ...queryResult, error: 'Mock error text', isError: true };
  }

  return queryResult;
};
